import $ from 'jquery';
import { GetElement } from '@/libs/util';

type Show = (
  isDecreased: IsDecreased,
  createMessage: CreateMessage,
  invokeCartSuccessPopupAction: InvokeCartSuccessPopupAction,
  isCartAutoCompleteUser: boolean
) => (
  isDeleteAction: boolean,
  errorMessage: string,
  currentPrice: number,
  beforeCurrentPrice: number,
  cartSuccessPopupAction: CallableFunction
) => void;

type IsDecreased = (
  currentPrice: number,
  beforeCurrentPrice: number
) => boolean;

type CreateMessage = (
  isDeleteAction: boolean,
  errorMessage: string,
  isDecreased: boolean,
  isCartAutoCompleteUser: boolean
) => string;

type InvokeCartSuccessPopupAction = (
  cartSuccessPopupAction: CallableFunction,
  message: string,
  isServiceError: boolean
) => void;

type InvokeShowPopup = (wcElement: any, message: string) => void;

type ShowElement = (
  selector: string,
  getElement: GetElement,
  invokeShowPopup: InvokeShowPopup
) => (message: string) => void;

/**
 * ポップアップのテキストを変更しポップアップの表示の関数を呼び出す
 * @param isDecreased 小計が下がっているかの判定の関数
 * @param createMessage メッセージを作成する関数
 * @param invokeCartSuccessPopupAction ポップアップを表示させる関数を呼び出す関数
 * @param isCartAutoCompleteUser カート自動保存ユーザーか
 */
export const show: Show = (
  isDecreased,
  createMessage,
  invokeCartSuccessPopupAction,
  isCartAutoCompleteUser
) => (
  isDeleteAction,
  errorMessage,
  currentPrice,
  beforeCurrentPrice,
  cartSuccessPopupAction
) => {
  const message = createMessage(
    isDeleteAction,
    errorMessage,
    isDecreased(currentPrice, beforeCurrentPrice),
    isCartAutoCompleteUser
  );
  invokeCartSuccessPopupAction(
    cartSuccessPopupAction,
    message,
    errorMessage !== ''
  );
};

/**
 * 小計が下がっているかの判定
 * @param currentPrice 現在の小計
 * @param beforeCurrentPrice 更新前の小計
 * @returns boolean
 */
export const isDecreased: IsDecreased = (currentPrice, beforeCurrentPrice) =>
  currentPrice <= beforeCurrentPrice;

/**
 * メッセージを作成する
 * @param isDeleteAction 削除されたか
 * @param errorMessage エラーメッセージ
 * @param isDecreased 小計が下がっているか
 * @param isCartAutoCompleteUser カート自動保存ユーザーか
 * @returns string メッセージ
 */
export const createMessage: CreateMessage = (
  isDeleteAction,
  errorMessage,
  isDecreased,
  isCartAutoCompleteUser
) => {
  if (errorMessage) return errorMessage;
  const message = isDeleteAction
    ? '削除しました'
    : isDecreased
    ? '変更しました'
    : '追加しました';
  return isCartAutoCompleteUser ? message + '（自動保存）' : message;
};

/**
 * ポップアップを表示させる関数を呼び出す
 * @param cartSuccessPopupAction ポップアップを表示させる関数
 * @param message ポップアップに表示させるメッセージ
 * @param isServiceError サービスエラーかどうか
 * @returns void
 */
export const invokeCartSuccessPopupAction: InvokeCartSuccessPopupAction = (
  cartSuccessPopupAction,
  message,
  isServiceError
) => {
  isServiceError ? alert(message) : cartSuccessPopupAction(message);
};

/**
 * VueコンポーネントのshowPopup関数を呼び出す
 * @param wcElement WC要素
 * @param message メッセージ
 * @returns void
 */
export const invokeShowPopup: InvokeShowPopup = (wcElement, message) => {
  wcElement.vueComponent?.$children[0].showPopup(message);
};

/**
 * ポップアップを表示する
 * @param selector 対象要素のセレクタ
 * @param getElement 要素の取得を行う関数
 * @param invokeShowPopup VueコンポーネントのshowPopup関数を呼び出す関数
 * @param message メッセージ
 * @returns void
 */
export const showElement: ShowElement = (
  selector,
  getElement,
  invokeShowPopup
) => (message) => {
  const wcElement = getElement(selector);
  if (wcElement) return invokeShowPopup(wcElement, message);
  const $popup = $('#cart-action-popup');
  const $popupText = $('.js-cart-popup-text');
  $popup.attr('data-popup-status', 'cartin');
  $popupText.html(message);
  $popup.css({
    bottom: $('#js-nav-fix-inner').height(),
  });
};
